import { Navigate, Outlet } from 'react-router-dom';

import useIsReadOnly from 'commons/utils/hooks/useIsReadOnly';

import { ROUTES } from './constants';

const ReadOnlyGuard = () => {
  const readOnly = useIsReadOnly();

  if (readOnly) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default ReadOnlyGuard;
